import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export const getOwnershipValue = amount => amount === null || amount === undefined // eslint-disable-line no-undefined
  ? null
  : Number(amount).toFixed(8);

class OwnershipCellRenderer extends PureComponent {
  static propTypes = {
    value: PropTypes.oneOfType([
      PropTypes.number.isRequired,
      PropTypes.string.isRequired,
    ]),
  };

  render() {
    return <span>{getOwnershipValue(this.props.value)}</span>;
  }
}

export default OwnershipCellRenderer;
